"use strict";

var _slicedToArray = require("/app/react/marvin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _chunkSSOLMJ6Rjs = require('./chunk-SSOLMJ6R.js');

var _chunk6R5OOOHCjs = require('./chunk-6R5OOOHC.js');

var o = {
  blue100: "#01064B",
  blue125: "#0F3265",
  blue150: "#15468E",
  blue200: "#1E64CB",
  blue250: "#729DE0",
  blue300: "#BCD1EF",
  blue400: "#D7E4F8",
  blue500: "#F4F7FD",
  concrete100: "#000005",
  concrete200: "#5C5C5F",
  concrete300: "#9E9EA0",
  concrete400: "#E0E0E1",
  concrete500: "#F2F2F3",
  concrete600: "#FAFAFA",
  green100: "#005838",
  green200: "#01AA6D",
  green500: "#F3FBF8",
  red100: "#BA3800",
  red200: "#FF4D00",
  red300: "#FF824D",
  red400: "#FFE0D3",
  red500: "#FFF6F2",
  sky100: "#2FA8F2",
  sky500: "#F5FBFE",
  transparent00: "#00000500",
  transparent05: "#0000050D",
  transparent20: "#00000533",
  transparent40: "#00000566",
  white: "#FFFFFF",
  yellow100: "#EB9B00",
  yellow200: "#FFA800",
  yellow300: "#FFCB66",
  yellow400: "#FFE5B3",
  yellow50: "#FF7B00",
  yellow500: "#FFFBF2",
  yellow75: "#FF8D00"
},
    t = "".concat(o.blue200, "40"),
    r = "".concat(o.concrete400, "80"),
    c = "".concat(o.concrete200, "80"),
    s = exports.b = o,
    i = {
  border: {
    radius: _chunkSSOLMJ6Rjs.c,
    width: _chunkSSOLMJ6Rjs.d
  },
  brand: "Proxibid",
  breakpoints: _chunkSSOLMJ6Rjs.b,
  core: o,
  spacing: _chunkSSOLMJ6Rjs.a
},
    g = exports.c = {
  "button.border.radius": _chunkSSOLMJ6Rjs.c.zero,
  "button.favorite.default.color.background": o.white,
  "button.favorite.default.color.border": o.concrete200,
  "button.favorite.disabled.color.background": o.white,
  "button.favorite.disabled.color.border": o.concrete300,
  "button.favorite.hover.color.background": o.red500,
  "button.favorite.hover.color.border": o.red200,
  "button.favorite.pressed.color.background": o.red500,
  "button.favorite.pressed.color.border": o.red200,
  "button.favorite.selected.color.background": o.white,
  "button.favorite.selected.color.border": o.red100,
  "button.inline.alt.default.color.text": o.red100,
  "button.inline.alt.hover.color.text": o.red200,
  "button.inline.alt.pressed.color.text": o.red300,
  "button.inline.default.color.text": o.blue200,
  "button.inline.hover.color.text": o.blue250,
  "button.inline.inverse.color.text": o.white,
  "button.inline.pressed.color.text": o.blue200,
  "button.inline.weak.color.text": o.concrete200,
  "button.primary.alt.color.background": o.red200,
  "button.primary.alt.color.border": o.yellow50,
  "button.primary.alt.color.text": o.white,
  "button.primary.alt.focused.color.background": o.red200,
  "button.primary.alt.hover.color.background": o.yellow50,
  "button.primary.alt.hover.color.border": o.yellow50,
  "button.primary.alt.pressed.color.background": o.yellow200,
  "button.primary.alt.pressed.color.border": o.yellow50,
  "button.primary.color.background": o.blue200,
  "button.primary.color.text": o.white,
  "button.primary.focused.color.background": o.blue200,
  "button.primary.hover.color.background": o.blue150,
  "button.primary.pressed.color.background": o.blue125,
  "button.secondary.alt.color.background": o.white,
  "button.secondary.alt.color.border": o.red200,
  "button.secondary.alt.color.text": o.red200,
  "button.secondary.alt.focused.color.background": o.red200,
  "button.secondary.alt.focused.color.text": o.white,
  "button.secondary.alt.hover.color.background": o.red500,
  "button.secondary.alt.hover.color.border": o.red200,
  "button.secondary.alt.hover.color.text": o.red200,
  "button.secondary.alt.pressed.color.background": o.red400,
  "button.secondary.alt.pressed.color.border": o.red200,
  "button.secondary.color.background": o.white,
  "button.secondary.color.border": o.blue200,
  "button.secondary.color.text": o.blue200,
  "button.secondary.focused.color.background": o.blue200,
  "button.secondary.hover.color.background": o.blue500,
  "button.secondary.hover.color.border": o.blue200,
  "button.secondary.hover.color.text": o.blue200,
  "button.secondary.pressed.color.background": o.blue400,
  "button.secondary.pressed.color.border": o.blue200,
  "button.tertiary.color.text": o.blue200,
  "button.tertiary.hover.color.background": o.concrete500,
  "button.tertiary.pressed.color.background": o.concrete400,
  "checkbox.border.radius": _chunkSSOLMJ6Rjs.c.zero,
  "color.background.critical.dark": o.red200,
  "color.background.critical.light": o.red500,
  "color.background.decorative": o.sky500,
  "color.background.disabled": o.concrete400,
  "color.background.field.default": o.white,
  "color.background.hover": o.concrete500,
  "color.background.info.dark": o.blue200,
  "color.background.info.light": o.blue500,
  "color.background.inverse": o.blue200,
  "color.background.neutral.dark": o.concrete200,
  "color.background.neutral.light": o.concrete500,
  "color.background.pressed": o.concrete400,
  "color.background.primary": o.white,
  "color.background.secondary": o.blue500,
  "color.background.subdued": o.concrete600,
  "color.background.success.dark": o.green100,
  "color.background.success.light": o.green500,
  "color.background.tertiary": o.blue100,
  "color.background.warning.dark": o.yellow200,
  "color.background.warning.light": o.yellow500,
  "color.border.critical": o.red200,
  "color.border.disabled": o.concrete300,
  "color.border.divider.black": o.concrete100,
  "color.border.divider.dark": o.concrete200,
  "color.border.divider.default": o.concrete400,
  "color.border.divider.inverse": o.white,
  "color.border.divider.light": o.concrete500,
  "color.border.focused.default": o.blue200,
  "color.border.focused.inverse": o.white,
  "color.border.hover": o.blue250,
  "color.border.info": o.blue200,
  "color.border.selected": o.blue200,
  "color.border.success": o.green200,
  "color.border.warning": o.yellow100,
  "color.icon.active": o.blue200,
  "color.icon.critical": o.red200,
  "color.icon.decorative.alt": o.blue200,
  "color.icon.decorative.default": o.sky100,
  "color.icon.decorative.light": o.sky500,
  "color.icon.default": o.concrete200,
  "color.icon.disabled": o.concrete300,
  "color.icon.hover": o.blue250,
  "color.icon.info": o.blue200,
  "color.icon.inverse": o.white,
  "color.icon.primary.alt.active": o.red100,
  "color.icon.primary.alt.default": o.red100,
  "color.icon.primary.alt.hover": o.red200,
  "color.icon.primary.default": o.blue200,
  "color.icon.success": o.green200,
  "color.icon.warning.default": o.concrete100,
  "color.icon.warning.light": o.yellow200,
  "color.keyboardFocus": "".concat(o.blue200, "80"),
  "color.keyboardFocusInverse": "".concat(o.white, "80"),
  "color.shadow.01": t,
  "color.shadow.02": r,
  "color.shadow.03": c,
  "color.skeleton.default": o.concrete500,
  "color.text.alt": o.white,
  "color.text.critical": o.red100,
  "color.text.disabled": o.concrete300,
  "color.text.error": o.red100,
  "color.text.inactive": o.concrete300,
  "color.text.info": o.blue100,
  "color.text.inverse": o.white,
  "color.text.link.active": o.blue200,
  "color.text.link.alt.active": o.red100,
  "color.text.link.alt.default": o.red100,
  "color.text.link.alt.focused": o.red100,
  "color.text.link.alt.hover": o.red200,
  "color.text.link.default": o.blue200,
  "color.text.link.disabled": o.concrete300,
  "color.text.link.focused": o.blue200,
  "color.text.link.hover": o.blue250,
  "color.text.link.inverse": o.white,
  "color.text.link.monochrome": o.concrete100,
  "color.text.link.weak": o.concrete200,
  "color.text.standard": o.concrete100,
  "color.text.success": o.green100,
  "color.text.weak": o.concrete200,
  "color.transparent00": o.transparent00,
  "color.transparent05": o.transparent05,
  "color.transparent20": o.transparent20,
  "color.transparent40": o.transparent40,
  "elevation.01": "0px 4px 4px ".concat(r),
  "elevation.02": "0px 1px 4px ".concat(t, ", 0px 1px 8px ").concat(r),
  "elevation.03": "0px 2px 8px ".concat(t, ", 0px 4px 16px ").concat(r),
  "elevation.04": "0px 3px 12px ".concat(c, ", 0px 6px 24px ").concat(t),
  "elevation.05": "0px -4px 4px ".concat(r),
  "input.border.radius": _chunkSSOLMJ6Rjs.c.zero,
  "typography.body.primary.family": "Roboto",
  "typography.body.primary.height": "24px",
  "typography.body.primary.size": "16px",
  "typography.body.primary.spacing": "0.5px",
  "typography.body.primary.style": "normal",
  "typography.body.primary.weight": 400,
  "typography.body.secondary.family": "Roboto",
  "typography.body.secondary.height": "22px",
  "typography.body.secondary.size": "14px",
  "typography.body.secondary.spacing": "0.5px",
  "typography.body.secondary.style": "normal",
  "typography.body.secondary.weight": 400,
  "typography.button.100.family": "Roboto",
  "typography.button.100.height": "10px",
  "typography.button.100.size": "14px",
  "typography.button.100.spacing": "1px",
  "typography.button.100.style": "normal",
  "typography.button.100.transform": "uppercase",
  "typography.button.100.weight": 700,
  "typography.button.200.family": "Roboto",
  "typography.button.200.height": "9px",
  "typography.button.200.size": "12px",
  "typography.button.200.spacing": "1px",
  "typography.button.200.style": "normal",
  "typography.button.200.transform": "uppercase",
  "typography.button.200.weight": 700,
  "typography.caption.100.family": "Roboto",
  "typography.caption.100.height": "18px",
  "typography.caption.100.size": "12px",
  "typography.caption.100.spacing": "0.5px",
  "typography.caption.100.style": "normal",
  "typography.caption.100.weight": 400,
  "typography.heading.000.family": "DIN2014 Regular",
  "typography.heading.000.height": "72px",
  "typography.heading.000.size": "48px",
  "typography.heading.000.spacing": "0px",
  "typography.heading.000.style": "normal",
  "typography.heading.000.weight": 400,
  "typography.heading.100.family": "DIN2014 Regular",
  "typography.heading.100.height": "48px",
  "typography.heading.100.mobile.family": "DIN2014 Regular",
  "typography.heading.100.mobile.height": "36px",
  "typography.heading.100.mobile.size": "24px",
  "typography.heading.100.mobile.spacing": "0px",
  "typography.heading.100.mobile.style": "normal",
  "typography.heading.100.mobile.weight": 400,
  "typography.heading.100.size": "32px",
  "typography.heading.100.spacing": "0px",
  "typography.heading.100.style": "normal",
  "typography.heading.100.weight": 400,
  "typography.heading.200.family": "DIN2014 Regular",
  "typography.heading.200.height": "36px",
  "typography.heading.200.mobile.family": "DIN2014 Regular",
  "typography.heading.200.mobile.height": "30px",
  "typography.heading.200.mobile.size": "20px",
  "typography.heading.200.mobile.spacing": "0px",
  "typography.heading.200.mobile.style": "normal",
  "typography.heading.200.mobile.weight": 400,
  "typography.heading.200.size": "24px",
  "typography.heading.200.spacing": "0px",
  "typography.heading.200.style": "normal",
  "typography.heading.200.weight": 400,
  "typography.heading.300.family": "DIN2014 Regular",
  "typography.heading.300.height": "30px",
  "typography.heading.300.mobile.family": "DIN2014 Regular",
  "typography.heading.300.mobile.height": "24px",
  "typography.heading.300.mobile.size": "16px",
  "typography.heading.300.mobile.spacing": "0px",
  "typography.heading.300.mobile.style": "normal",
  "typography.heading.300.mobile.weight": 400,
  "typography.heading.300.size": "20px",
  "typography.heading.300.spacing": "0px",
  "typography.heading.300.style": "normal",
  "typography.heading.300.weight": 400,
  "typography.heading.400.family": "DIN2014 Regular",
  "typography.heading.400.height": "24px",
  "typography.heading.400.size": "16px",
  "typography.heading.400.spacing": "0px",
  "typography.heading.400.style": "normal",
  "typography.heading.400.weight": 400,
  "typography.heading.500.family": "Roboto",
  "typography.heading.500.height": "24px",
  "typography.heading.500.size": "16px",
  "typography.heading.500.spacing": "0.5px",
  "typography.heading.500.style": "normal",
  "typography.heading.500.weight": 700,
  "typography.heading.600.family": "Roboto",
  "typography.heading.600.height": "22px",
  "typography.heading.600.size": "14px",
  "typography.heading.600.spacing": "1px",
  "typography.heading.600.style": "normal",
  "typography.heading.600.transform": "uppercase",
  "typography.heading.600.weight": 700,
  "typography.label.mini.family": "Roboto",
  "typography.label.mini.height": "14px",
  "typography.label.mini.size": "12px",
  "typography.label.mini.spacing": "1px",
  "typography.label.mini.style": "normal",
  "typography.label.mini.transform": "uppercase",
  "typography.label.mini.weight": 400,
  "typography.label.strong.family": "Roboto",
  "typography.label.strong.height": "22px",
  "typography.label.strong.size": "14px",
  "typography.label.strong.spacing": "0.5px",
  "typography.label.strong.style": "normal",
  "typography.label.strong.weight": 700
};
Object.entries(g).forEach(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      y = _ref2[0],
      d = _ref2[1];

  return _chunk6R5OOOHCjs.a.call(void 0, i, y, d);
});
var u = i;
exports.a = o;
exports.b = s;
exports.c = g;
exports.d = u;